import { render, staticRenderFns } from "./OneScreenDialog.vue?vue&type=template&id=a383986c"
import script from "./OneScreenDialog.vue?vue&type=script&lang=js"
export * from "./OneScreenDialog.vue?vue&type=script&lang=js"
import style0 from "./OneScreenDialog.vue?vue&type=style&index=0&id=a383986c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports